// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3265d2b1","453":"96063161"}[chunkId] + ".chunk.js";
};